var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.549.927c.3-.921 1.603-.921 1.902 0L17.98 8.71a1 1 0 0 0 .951.691h8.184c.969 0 1.371 1.24.588 1.81l-6.621 4.81a1 1 0 0 0-.364 1.117l2.53 7.784c.299.921-.756 1.687-1.54 1.118l-6.62-4.81a1 1 0 0 0-1.176 0l-6.62 4.81c-.784.57-1.839-.197-1.54-1.118l2.53-7.784a1 1 0 0 0-.364-1.118l-6.62-4.81c-.784-.57-.381-1.809.587-1.809h8.184a1 1 0 0 0 .951-.69L13.549.926Z"
  })));
};
export default SvgStar;